import { render } from "./CourseContentView.vue?vue&type=template&id=6e5b89ad&scoped=true"
import script from "./CourseContentView.vue?vue&type=script&lang=js"
export * from "./CourseContentView.vue?vue&type=script&lang=js"

import "./CourseContentView.vue?vue&type=style&index=0&id=6e5b89ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5b89ad"]])

export default __exports__